(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[754],{

/***/ 6156:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acquisitions",
      function () {
        return __webpack_require__(8298);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _app_components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6625);
/* harmony import */ var _app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3725);
/* harmony import */ var _app_constants_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9510);
/* harmony import */ var _app_contexts_theme_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9746);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);







var ConnectSection = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "dark" : _variant;
    var isLightVariant = variant === "light";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var isMobile = (0,_app_contexts_theme_context__WEBPACK_IMPORTED_MODULE_3__/* .useThemeContext */ .TC)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-4 pt-8 md:px-12 md:pt-12 lg:px-24 lg:pt-24 ".concat(isLightVariant ? "" : "bg-background-primary-dark-dark", "  \n      flex flex-col items-center justify-between md:gap-y-16"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-y-5 items-center text-center max-w-[700px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "h4 md:h3",
                            children: isLightVariant ? "Let's get connected!" : "Connect with us!"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-body-md lg:subheading ".concat(isLightVariant ? "text-text-color-mid-em" : "text-light"),
                        children: isLightVariant ? "If your company is looking for a strong partner within the waste and recycling industry, we'd like to hear from you." : "If you're looking for a strong partner within the waste and recycling\n          industry, we'd like to hear from you."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "py-5 w-full md:w-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            buttonType: "gradient",
                            onClick: function() {
                                return router.push("/".concat(_app_constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .CONTACT_PAGE */ .rU));
                            },
                            full: isMobile,
                            className: isMobile ? "rounded-full" : "",
                            children: isLightVariant ? "Connect with us!" : "Let's connect!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "rounded-t-3xl border overflow-hidden border-4 xs:border-8 border-b-0 h-fit -mb-2 xs:-mb-4\n        ".concat(isLightVariant ? "border-black" : "border-white"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    width: 1216,
                    height: 428,
                    src: "/images/acquisitions/connect.png",
                    alt: "Join us"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConnectSection);


/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 8298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ acquisitions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/acquisitions-sections/advantage-section/index.tsx



var AdvantageSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-8 py-12 md:p-12 lg:p-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-12 max-w-[1440px] mx-auto md:gap-x-10 lg:gap-x-16 xl:gap-x-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-12 md:col-span-6 flex flex-col justify-center items-end gap-y-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-4 text-left w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                                overrideClassName: "mobile-h2 md:h3 lg:h2 py-2",
                                children: "Take advantage of your options."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-body-xl text-text-color-mid-em",
                                children: "Attention to detail, by design. A careful review of your business is our promise. Let\u2019s explore what we can do together."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-12 md:col-span-6 flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-4/5 pt-10 md:pt-0 md:w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "rounded-lg",
                            src: "/images/acquisitions/advantage-section.png",
                            alt: "Advantages",
                            width: 560,
                            height: 640
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var advantage_section = (AdvantageSection);

;// CONCATENATED MODULE: ./components/acquisitions-sections/company-outlook-section/bottom-content.tsx


var CompanyOutlookSectionBottomContent = function() {
    var sectionContents = [
        {
            title: "Fair, respectful, detailed.",
            underlineColorClass: "bg-secondary-light",
            content: "We promise to give you a fair value for your business, delivered with simplicity and confidentiality. \n      We provide ancillary opportunities to your customers with exceptional customer service. \n      We offer your employees benefits packages and options for continued growth.\u200B"
        },
        {
            title: "Selecting the right partner.",
            underlineColorClass: "bg-primary-light",
            content: "We provide excellent benefits for our acquisition partners. \n      These benefits include employee retention, the opportunity to retain your company name, national acquisition interest, creative deal structuring.\u200B"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse lg:grid lg:grid-cols-12 2xl:w-2/3 overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:col-span-5 mt-16 lg:mt-0 flex justify-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[600px] rounded-2xl h-full w-full bg-cover bg-right-top bg-no-repeat",
                    style: {
                        backgroundImage: "url('/images/acquisitions/company-outlook-02.png')"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:col-span-7 flex flex-col items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-start justify-center lg:p-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            overrideClassName: "mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "label-lg",
                                children: "Our company traits"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col space-y-10 lg:space-y-20",
                            children: sectionContents.map(function(content) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mobile-h3 md:h5 lg:h3 text-base-dark",
                                            children: content.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-2 w-[200px] ".concat(content.underlineColorClass)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "subheading text-text-color-mid-em",
                                            children: content.content
                                        })
                                    ]
                                }, content.title);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var bottom_content = (CompanyOutlookSectionBottomContent);

;// CONCATENATED MODULE: ./components/acquisitions-sections/company-outlook-section/top-content.tsx


var CompanyOutlookSectionTopContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 2xl:w-2/3 bg-primary-low-em/50 rounded-2xl overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-7 flex flex-col items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-start justify-center p-8 md:p-16 space-y-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/icons/eye-gradient.png",
                            width: 48,
                            height: 48,
                            alt: "outlook"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h4 md:h5 lg:h4 text-primary-dark",
                            children: "Company Outlook"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-body-lg text-text-color-mid-em",
                            children: [
                                "At",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-secondary-dark label-lg-bold",
                                    children: "SimpleWaste"
                                }),
                                " ",
                                "we\u2019re positioned to expand our company and our reach. The innovation our technology brings to the industry extends beyond waste and recycling and merges into other facility-related services.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Your customers will reap the benefits of our strong position and leading-edge technology. Our expansion capabilities occupy no borders."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-5 flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[364px] h-full w-full bg-cover bg-right bg-no-repeat",
                    style: {
                        backgroundImage: "url('/images/acquisitions/company-outlook-01.jpg')"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var top_content = (CompanyOutlookSectionTopContent);

;// CONCATENATED MODULE: ./components/acquisitions-sections/company-outlook-section/index.tsx



var CompanyOutlookSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col items-center px-8 py-16 md:p-12 space-y-10 md:space-y-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_content, {})
        ]
    });
};
/* harmony default export */ var company_outlook_section = (CompanyOutlookSection);

// EXTERNAL MODULE: ./components/connect-section.tsx
var connect_section = __webpack_require__(221);
// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
// EXTERNAL MODULE: ./node_modules/@mdi/react/Icon.js
var Icon = __webpack_require__(8849);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);
// EXTERNAL MODULE: ./node_modules/@mdi/js/mdi.js
var mdi = __webpack_require__(5317);
// EXTERNAL MODULE: ./contexts/theme-context.tsx
var theme_context = __webpack_require__(9746);
;// CONCATENATED MODULE: ./components/acquisitions-sections/employees-section/bottom-content.tsx





var EmployeesSectionBottomContent = function() {
    var isMobile = (0,theme_context/* useThemeContext */.TC)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 w-full gap-y-8",
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-5 flex flex-row items-center justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:w-[560px] flex flex-col space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                            overrideClassName: "p-3 mb-2 w-12 rounded-full shadow-outer-secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                size: 1,
                                path: mdi/* mdiNumericPositive1 */.MUM
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h4 md:h5 lg:h4",
                            children: "Join with SimpleWaste"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-body-lg",
                            children: "We understand that selecting the right company to sell your business to can be a very personal and challenging decision. Part of our pathway to success has been to procure businesses whose ownership is looking for a seamless and graceful exit strategy. SimpleWaste provides unparalleled advantages for owners who are considering selling their business.\u200B"
                        })
                    ]
                })
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 md:col-span-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[512px] h-full w-full bg-cover bg-top bg-no-repeat rounded-xl md:rounded-tr-none md:rounded-br-none md:rounded-tl-xl md:rounded-bl-xl",
                    style: {
                        backgroundImage: "url('/images/acquisitions/employees-section-2.png')"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var employees_section_bottom_content = (EmployeesSectionBottomContent);

;// CONCATENATED MODULE: ./components/acquisitions-sections/employees-section/header.tsx


var EmployeesSectionHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center space-y-4 w-full md:w-[440px] text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mobile-h3 md:h4 lg:h3",
                children: "Employees and customers come first"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-2 w-36"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "py-4 text-body-xl",
                children: "No worries, we've got you covered."
            })
        ]
    });
};
/* harmony default export */ var header = (EmployeesSectionHeader);

;// CONCATENATED MODULE: ./components/acquisitions-sections/employees-section/mid-content.tsx





var EmployeesSectionMidContent = function() {
    var isMobile = (0,theme_context/* useThemeContext */.TC)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse md:grid md:grid-cols-12 w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-5 mt-8 md:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[512px] h-full w-full bg-cover bg-center bg-no-repeat rounded-xl md:rounded-tl-none md:rounded-bl-none md:rounded-tr-xl md:rounder-br-xl",
                    style: {
                        backgroundImage: "url('/images/acquisitions/employees-section-1.png')"
                    }
                })
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-5 flex flex-row items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:w-[560px] flex flex-col space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                            overrideClassName: "p-3 mb-2 w-12 rounded-full shadow-outer-secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                size: 1,
                                path: mdi/* mdiAccountOutline */.jiR
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mobile-h4 md:h5 lg:h4",
                            children: "Customer Advantages"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-body-lg",
                            children: "Our platform is guaranteed to deliver the innovation and value your customers deserve. We pride ourselves in taking care of your clients by ensuring their immediate and long-term service needs are met with the utmost attention to detail."
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var mid_content = (EmployeesSectionMidContent);

;// CONCATENATED MODULE: ./components/acquisitions-sections/employees-section/index.tsx




var EmployeesSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "px-8 py-16 md:px-0 md:py-24 bg-background-primary-dark-dark text-light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center space-y-8 md:space-y-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mid_content, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(employees_section_bottom_content, {})
            ]
        })
    });
};
/* harmony default export */ var employees_section = (EmployeesSection);

;// CONCATENATED MODULE: ./pages/acquisitions.tsx





var AcquisitionsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(advantage_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(employees_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_outlook_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(connect_section/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var acquisitions = (AcquisitionsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6156); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);